/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_MartaInputs */

const en_platform_preview_marta = /** @type {(inputs: Platform_Preview_MartaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marta Nowak · Mobility`)
};

const pl_platform_preview_marta = /** @type {(inputs: Platform_Preview_MartaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marta Nowak · Mobilność`)
};

/**
* | output |
* | --- |
* | "Marta Nowak · Mobility" |
*
* @param {Platform_Preview_MartaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_marta = /** @type {((inputs?: Platform_Preview_MartaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_MartaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_marta(inputs)
	return en_platform_preview_marta(inputs)
});